<template>
    <div class="company_info">
        <div class="pl-1">
            <div>
                <BButton variant="outline-primary" @click="update_item" class="mb-2 mt-2">
                    Оновити інформацію
                </BButton>
            </div>
            
            <span v-if="rows.udata">
                <span> Дата оновлення:</span> {{ rows.date }}
            </span>
        </div>
        
        <div class="mt-5" v-if="rows.udata">
            <BTabs v-model="activeTab" pills card>
                
                <!-- TAB A: Загальна інформація -->
                <BTab>
                    <template #title>
                        Загальна інформація
                        <i v-if="chk_info" class="far fa-exclamation-triangle text-danger ms-2"></i>
                    </template>
                    
                    <BListGroup>
                        <BListGroupItem v-if="rows.udata.companyshort">
                            <span>Коротка назва:</span> {{ rows.udata.companyshort }}
                            <BButton variant="outline-primary" class="mb-2 mt-2 ms-2"
                                     @click="update_name(rows.udata.companyshort)">
                                Перенести назву в профіль
                            </BButton>
                        </BListGroupItem>
                        
                        <BListGroupItem v-else>
                            <span>Коротка назва:</span> {{ rows.udata.company }}
                            <BButton variant="outline-primary" class="mb-2 mt-2 ms-2"
                                     @click="update_name(rows.udata.company)">
                                Перенести назву в профіль
                            </BButton>
                        </BListGroupItem>
                        
                        <BListGroupItem><span>ЄРДПОУ:</span> {{ rows.edrpou }}</BListGroupItem>
                        <BListGroupItem><span>Організаційно-правова форма:</span> {{ rows.udata.olf_name }}</BListGroupItem>
                        <BListGroupItem :variant="chk_status ? 'warning' : ''">
                            <span>Статус:</span> {{ rows.udata.state_text }}
                        </BListGroupItem>
                        <BListGroupItem :variant="chk_create ? 'warning' : ''">
                            <span>Дата державної реєстрації:</span> {{ rows.udata.registration_date | moment }}
                        </BListGroupItem>
                        <BListGroupItem :variant="chk_calital ? 'warning' : ''">
                            <span>Розмір статутного капіталу:</span>
                            {{ rows.udata.authorised_capital.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") }} грн.
                        </BListGroupItem>
                        <BListGroupItem><span>Адреса реєстрації:</span> {{ rows.udata.address }}</BListGroupItem>
                        <BListGroupItem><span>Основний вид діяльності згідно КВЕД:</span> {{ rows.udata.primary_activity_kind }}</BListGroupItem>
                        <BListGroupItem><span>Ліцензії, дозволи:</span> {{ rows.udata.licenses }}</BListGroupItem>
                        <BListGroupItem :variant="chk_employers ? 'warning' : ''">
                            <span>Кількість персоналу:</span> {{ rows.udata.employers.num_employers }} ({{ rows.udata.employers.year }} рік)
                        </BListGroupItem>
                        <BListGroupItem><span>Керівник:</span> {{ rows.udata.chiefCurrent }}</BListGroupItem>
                        <BListGroupItem><span>Кінцевий бенефіціар(и):</span> {{ rows.udata.beneficiaries }}</BListGroupItem>
                        <BListGroupItem :variant="rows.udata.termination != null ? 'warning' : ''">
                            <span>Відомості про припинення/реорганізацію юр особи:</span> {{ rows.udata.termination }}
                        </BListGroupItem>
                        <BListGroupItem :variant="rows.udata.bankruptcy != null ? 'warning' : ''">
                            <span>Відомості про банкрутство:</span> {{ rows.udata.bankruptcy }}
                        </BListGroupItem>
                        <BListGroupItem :variant="rows.udata.sanctions != 'False' ? 'warning' : ''">
                            <span>Зв'язки із компаніями під санкціями:</span> {{ rows.udata.sanctions }}
                        </BListGroupItem>
                        <BListGroupItem><span>Участь у державних тендерах:</span> {{ rows.udata.tenders }}</BListGroupItem>
                        <BListGroupItem :variant="chk_borgZP ? 'warning' : ''">
                            <span>Заборгованість по заробітній платі:</span>
                            {{ rows.udata.debtorsBorgZP.borg }} грн. ({{ rows.udata.financialBKI.year }} рік)
                        </BListGroupItem>
                    </BListGroup>
                </BTab>
                
                <!-- TAB B: Дані податкової -->
                <BTab>
                    <template #title>
                        Дані податкової
                        <i v-if="chk_borg" class="far fa-exclamation-triangle text-danger ms-2"></i>
                    </template>
                    
                    <BListGroup>
                        <BListGroupItem :variant="chk_borg ? 'warning' : ''">
                            <span>Податковий борг:</span>
                            {{ rows.udata.debtorsBorgTAX.borg.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") }}
                            грн. ({{ rows.udata.debtorsBorgTAX.period | moment }})
                        </BListGroupItem>
                        <BListGroupItem>
                            <span>Реєстр платників акцизного податку з реалізації пального:</span> {{ rows.udata.excise_tax }}
                        </BListGroupItem>
                        <BListGroupItem>
                            <span>Реєстр платників ПДВ:</span> {{ rows.udata.reestrPdv.state }} {{ rows.udata.reestrPdv.ipn }}
                        </BListGroupItem>
                        <BListGroupItem>
                            <span>Реєстр платників ПДВ статус:</span> {{ rows.udata.reestrPdvCancel.state }}
                            ({{ rows.udata.reestrPdvCancel.cancelDate }})
                        </BListGroupItem>
                        <BListGroupItem>
                            <span>Реєстр платників єдиного податку:</span> {{ rows.udata.reestrPed.state }}
                            ({{ rows.udata.reestrPed.cancelDate }})
                        </BListGroupItem>
                    </BListGroup>
                </BTab>
                
                <!-- TAB C: Фінансово-економічні показники -->
                <BTab>
                    <template #title>
                        Фінансово-економічні показники
                        <i v-if="chk_fin" class="far fa-exclamation-triangle text-danger ms-2"></i>
                    </template>
                    
                    <BListGroup>
                        <BListGroupItem :variant="chk_net_income ? 'warning' : ''">
                            <span>Виручка:</span>
                            {{ rows.udata.financialBKI.net_income.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") }}
                            грн. ({{ rows.udata.financialBKI.year }} рік)
                        </BListGroupItem>
                        <BListGroupItem :variant="chk_main_active ? 'warning' : ''">
                            <span>Основні засоби:</span>
                            {{ rows.udata.financialBKI.main_active.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") }}
                            грн. ({{ rows.udata.financialBKI.year }} рік)
                        </BListGroupItem>
                        <BListGroupItem :variant="chk_net_profit ? 'warning' : ''">
                            <span>Чистий прибуток:</span>
                            {{ rows.udata.financialBKI.net_profit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") }}
                            грн. ({{ rows.udata.financialBKI.year }} рік)
                        </BListGroupItem>
                        <BListGroupItem :variant="chk_current_liabilities ? 'warning' : ''">
                            <span>Поточні зобов'язання:</span>
                            {{ rows.udata.financialBKI.current_liabilities.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") }}
                            грн. ({{ rows.udata.financialBKI.year }} рік)
                        </BListGroupItem>
                    </BListGroup>
                </BTab>
                
                <!-- TAB D: Майно -->
                <BTab>
                    <template #title>Майно</template>
                    <BListGroup>
                        <BListGroupItem>
                            <span>Кількість об'єктів нерухомого майна у власності:</span> {{ rows.udata.RealEstate }}
                        </BListGroupItem>
                        <BListGroupItem>
                            <span>Кількість земельних ділянок у власності:</span> {{ rows.udata.realEstateRightsLand }}
                        </BListGroupItem>
                        <BListGroupItem>
                            <span>Кількість ТЗ у власності:</span> {{ rows.udata.vehicle }}
                        </BListGroupItem>
                    </BListGroup>
                </BTab>
                
                <!-- TAB E: Судова історія та виконавчі провадження -->
                <BTab>
                    <template #title>
                        Судова історія та виконавчі провадження
                        <i v-if="chk_courts_enforcements" class="far fa-exclamation-triangle text-danger ms-2"></i>
                    </template>
                    
                    <BListGroup>
                        <BListGroupItem :variant="chk_courts ? 'warning' : ''">
                            <span>Кількість судових справ:</span> {{ rows.udata.Courts }}
                        </BListGroupItem>
                        <BListGroupItem :variant="Number(rows.udata.CourtsinProcess)>0 ? 'warning' : ''">
                            <span>Кількість судових справ в процесі:</span> {{ rows.udata.CourtsinProcess }}
                        </BListGroupItem>
                        <BListGroupItem :variant="Number(rows.udata.CourtsDocs)>0 ? 'warning' : ''">
                            <span>Кількість судових документів:</span> {{ rows.udata.CourtsDocs }}
                        </BListGroupItem>
                        <BListGroupItem :variant="Number(rows.udata.CourtsDocsDefendant)>0 ? 'warning' : ''">
                            <span>… в якості відповідача:</span> {{ rows.udata.CourtsDocsDefendant }}
                        </BListGroupItem>
                        <BListGroupItem :variant="Number(rows.udata.CourtsDocsPlaintiff)>0 ? 'warning' : ''">
                            <span>… в якості Позивача:</span> {{ rows.udata.CourtsDocsPlaintiff }}
                        </BListGroupItem>
                        <BListGroupItem>
                            <span>За формою судочинства:</span>
                            <div v-for="(item, i) in rows.udata.listJusticeKindses" :key="i">
                                {{ item.name }} — {{ item.count }}
                            </div>
                        </BListGroupItem>
                        <BListGroupItem :variant="Number(rows.udata.enforcementsOrgCountDebtor)>0 ? 'warning' : ''">
                            <span>Виконавчих проваджень (боржник):</span> {{ rows.udata.enforcementsOrgCountDebtor }}
                        </BListGroupItem>
                        <BListGroupItem :variant="Number(rows.udata.enforcementsOrgCountCreditor)>0 ? 'warning' : ''">
                            <span>Виконавчих проваджень (стягувач):</span> {{ rows.udata.enforcementsOrgCountCreditor }}
                        </BListGroupItem>
                    </BListGroup>
                </BTab>
            
            </BTabs>
        </div>
        
        <ul v-else class="list-group company_full_info">
            <li class="list-group-item list-group-item-success">Немає даних</li>
        </ul>
    </div>
</template>

<script>

import {
    BTabs,
    BTab,
    BOverlay,
    BSpinner,
    BButton,
    BRow,
    BCol,
    BButtonGroup,
    BCard,
    BCardText,
    BCardHeader,
    BCollapse,
    BListGroup,
    BListGroupItem
} from 'bootstrap-vue-next';

export default {
    name: "company_info",
    
    components: {
        BTabs,
        BTab,
        BButton,
        BCard,
        BCardHeader,
        BCardText,
        BCollapse,
        BListGroup,
        BListGroupItem
    },
    
    props: {
        user_id: ''
    },
    
    created() {
        this.load_item();
    },
    
    data() {
        return {
            activeTab: 0,
            rows: {}
            
        }
    },
    
    mounted() {
    
    },
    
    filters: {
        moment: function (date) {
            return moment(date).format('DD.MM.YYYY');
        },
    },
    
    methods: {
        
        async load_item() {
            this.rows = [];
            await api.get('/tenders/sales/tenders/contragents/' + parseInt(this.user_id) + '/vkursi').then(({data}) => {
                if (data.status === "operation_success") {
                    this.rows = data.data?.msg;
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
            });
        },
        
        async update_item() {
            IMC_CORE.showloading();
            await api.patch('/tenders/sales/tenders/contragents/' + parseInt(this.user_id) + '/vkursi').then(({data}) => {
                if (data.status === "operation_success") {
                    this.load_item();
                    IMC_CORE.snackbar('Дані оновлено')
                }
                IMC_CORE.hideloading();
            }).catch(err => {
                IMC_CORE.snackbar('Помилка')
                IMC_CORE.hideloading();
                this.rows = [];
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
            });
        },
        
        async update_name(c_name) {
            
            await api.patch('/tenders/sales/tenders/contragents/' + parseInt(this.user_id) + '/title',{
                    user_id: this.user_id,
                    new_name: c_name
                }).then(({data}) => {
                    if (data.status === "operation_success") {
                        this.load_item();
                        IMC_CORE.snackbar('Дані оновлено')
                        EventBus.$emit('reload_contragent_info');
                    }
                }).catch(err => {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                });
        },
        
    },
    computed: {
        chk_info: function () {
            return this.chk_status || this.chk_create || this.chk_calital || this.chk_employers || this.chk_borgZP
        },
        
        chk_status: function () {
            let res = false
            console.log(this.rows.udata)
            if (this.rows.hasOwnProperty('udata')) {
                res = this.rows.udata.state_text != 'зареєстровано';
                console.log(this.rows.udata.state_text)
            }
            return res
            
        },
        chk_create: function () {
            let res = false
            if (this.rows.hasOwnProperty('udata')) {
                var d1 = new Date(this.rows.udata.registration_date);
                var d2 = new Date();
                var d1Y = d1.getFullYear();
                var d2Y = d2.getFullYear();
                var d1M = d1.getMonth();
                var d2M = d2.getMonth();
                res = (d2M + 12 * d2Y) - (d1M + 12 * d1Y) < 24;
            }
            return res
            
        },
        chk_calital: function () {
            let res = false
            if (this.rows.hasOwnProperty('udata')) {
                res = Number(this.rows.udata.authorised_capital) < 100000
            }
            return res
            
        },
        chk_employers: function () {
            let res = false
            
            if (this.rows.hasOwnProperty('udata')) {
                res = Number(this.rows.udata.employers.num_employers) < 10
            }
            return res
        },
        chk_borgZP: function () {
            let res = false
            if (this.rows.hasOwnProperty('udata')) {
                res = Number(this.rows.udata.debtorsBorgZP.borg) > 0
            }
            return res
            
        },
        
        ///////////////////////////////
        chk_borg: function () {
            let res = false
            if (this.rows.hasOwnProperty('udata')) {
                res = Number(this.rows.udata.debtorsBorgTAX.borg) > 0
            }
            return res
            
        },
        
        ///////////////////////////////
        chk_fin: function () {
            return this.chk_net_income || this.chk_main_active || this.chk_net_profit || this.chk_current_liabilities
            
        },
        
        chk_net_income: function () {
            let res = false
            if (this.rows.hasOwnProperty('udata')) {
                res = Number(this.rows.udata.financialBKI.net_income) < 100000
            }
            return res
        },
        
        chk_main_active: function () {
            let res = false
            if (this.rows.hasOwnProperty('udata')) {
                res = Number(this.rows.udata.financialBKI.main_active) < 100000
            }
            return res
        },
        
        chk_net_profit: function () {
            let res = false
            if (this.rows.hasOwnProperty('udata')) {
                res = Number(this.rows.udata.financialBKI.net_profit) < 0
            }
            return res
        },
        
        chk_current_liabilities: function () {
            let res = false
            if (this.rows.hasOwnProperty('udata')) {
                res = Number(this.rows.udata.financialBKI.net_income) < Number(this.rows.udata.financialBKI.current_liabilities)
            }
            return res
        },
        
        ////////////////////////////
        chk_courts_enforcements: function () {
            return this.chk_courts || this.chk_enforcements
        },
        
        chk_courts: function () {
            let res = false
            if (this.rows.hasOwnProperty('udata')) {
                res = Number(this.rows.udata.Courts) > 0
            }
            return res
        },
        
        chk_enforcements: function () {
            let res = false
            if (this.rows.hasOwnProperty('udata')) {
                res = Number(this.rows.udata.enforcementsOrgCountDebtor) + Number(this.rows.udata.enforcementsOrgCountCreditor) > 0
            }
            return res
        },
        
        
    }
}
</script>

<style scoped>


</style>
